import { Divider } from '@chakra-ui/react'
import { ArrowBackIcon } from '@chakra-ui/icons'

const ReturnDrawerMobile = ({ onClose }) => {
  return (
    <>
      <ArrowBackIcon
        color={'#0A0808'}
        h={6}
        marginLeft={6}
        marginTop={6}
        w={6}
        onClick={onClose}
      />
      <Divider paddingTop={'1rem'} />
    </>
  )
}

export default ReturnDrawerMobile
